import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import BigAd from '../components/BigAd'
import Product from '../components/Product'
import { products } from '../data'
import { HomePath } from '../home-path'

export default function ProductListings() {
  
if (!localStorage.getItem('reloadGN')) {
    localStorage.setItem('reloadGN', 'true');
    window.location.reload();
}
  let location = useLocation();
  const state  = location.state;
  const params = state;
  
  let filteredProducts = products?.filter(product => product?.brand === state);

  let filterType = [
    products?.filter(product => product?.brand === state),
    products?.filter(product => product?.sex === state),
  ]
  
  return (
    <>
    <div className="min-h-screen w-full py-12">
      <div className="mxw">
        <div className="w-full h-fit py-4 text-left">
            <p className="text-2xl md:text-3xl font-semibold">Our Products</p>
            {params && (
              <p className="text-md md:text-lg text-gray-500">Found {filteredProducts?.length} results for: <span className="font-semibold capitalize">{state}</span></p>
            )}
        </div>
        <div className="flex items-center justify-start w-full h-fit py-4 border-b border-gray-100">
            {/* <button className="py-1 px-2" value="all">All</button> */}
            {/* <button className="py-1 px-2" value="group_one">Group 1</button> */}
            {/* <button className="py-1 px-2" value="group_two">Group 2</button> */}
        </div>
      </div>
      <div className="mxw grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4 mt-6 place-items-center">
        {state && filteredProducts?.map(product => (
          <div className="h-full w-full">
            <Product product={product}/>
          </div>
        ))}
        {!state && products?.map(product => (
          <div key={product?.id} className="h-full w-full">
            <Product product={product}/>
          </div>
        ))}
      </div>
    </div>
    <BigAd route={HomePath + "/home"} minorHeading="Limited time only!" majorHeading="In this week!" text="Checkout our new products highlighted for you" buttonText="Shop Now!" />
    </>
  )
}
